/**
 * 新建与编辑
 */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { Modal, Select, Form, Input, message, InputNumber } from 'antd';
import model from '@/reducers/system/operatingrule/model';
import { connect } from 'react-redux';


const { Option } = Select;
const formLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
};

const EditInfo = ({
    onClose,
    modalParams,
    evaluateTypes,
    getEvaluateTypes,
}) => {

    const [confirmLoading, setConfirmLoading] = useState(false);
    const [form] = Form.useForm();


    useEffect(() => {
        getEvaluateTypes();//评价星级列表
    }, []);

    const onSubmit = () => {
        form.validateFields().then((values) => {
            let submitData = {
                id: Object.keys(modalParams).length === 0 ? undefined : modalParams.id,
                appraiseTypeId: values.appraiseTypeId,
                label: values.label,
                levelScore: values.levelScore,
                sortNo: values.sortNo,
            };
            let requireUrl = Object.keys(modalParams).length === 0 ? 'addContents' : 'updateContents';
            setConfirmLoading(true);
            http(`/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderAppraiseService.${requireUrl}`, submitData, 'POST')
                .then(() => {
                    message.success(Object.keys(modalParams).length === 0 ? '新建成功' : '更新成功');
                    onClose(true);
                })
                .catch((err = {}) => {
                    message.error(err.message);
                    setConfirmLoading(false);
                });
        }).catch((info) => { });
    };

    return <Modal
        title='评价标签'
        bodyStyle={{ paddingBottom: 0 }}
        centered
        destroyOnClose
        width={520}
        visible={true}
        confirmLoading={confirmLoading}
        onOk={onSubmit}
        onCancel={() => onClose(false)}
    >
        <Form
            id='editInfo'
            {...formLayout}
            autoComplete='off'
            name="create"
            scrollToFirstError
            initialValues={{
                appraiseTypeId: modalParams.appraiseTypeId,
                label: modalParams.label,
                levelScore: modalParams.levelScore,
                sortNo: modalParams.sortNo
            }}
            form={form}
        >
            <Form.Item
                name="appraiseTypeId"
                label='评价星级'
                colon={false}
                rules={[{ required: true, }]}>
                <Select
                    showSearch
                    style={{ width: '270px' }}
                    placeholder="请选择"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                        optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                    }
                >
                    {evaluateTypes.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
                </Select>
            </Form.Item>
            <Form.Item
                name="label"
                label="标签名称"
                colon={false}
                rules={[{ required: true, },
                ]}
            >
                <Input
                    style={{ width: 270 }}
                    placeholder="请输入"
                    suffix={<Form.Item
                        noStyle
                        shouldUpdate
                    >
                        {({ getFieldValue }) => {
                            return getFieldValue('label') ? (
                                <span key={getFieldValue('label')}>{getFieldValue('label').length}/20</span>
                            ) : <span>0/20</span>;
                        }}
                    </Form.Item>}
                    maxLength={20}
                />
            </Form.Item>
            <Form.Item
                name="levelScore"
                label="等级分值"
                colon={false}
                rules={[
                    { required: true, },
                    { type: 'number', min: -999, max: 999, }
                ]}>
                <InputNumber
                    style={{ width: 270, }}
                    keyboard={true}
                    placeholder='请输入(分)'
                    precision={0}
                />
            </Form.Item>
            <Form.Item
                name="sortNo"
                label="标签排序"
                colon={false}
                rules={[
                    { required: true, },
                    { type: 'number', min: 1, }
                ]}>
                <InputNumber
                    style={{ width: 270, }}
                    keyboard={true}
                    placeholder='请输入'
                    precision={0}
                />
            </Form.Item>
        </Form>
    </Modal>;
};

EditInfo.propTypes = {
    onClose: PropTypes.func.isRequired,//关闭操作
    modalParams: PropTypes.object,
    evaluateTypes: PropTypes.array,
    getEvaluateTypes: PropTypes.func,//评价星级列表action
};

export default connect(state => ({
    evaluateTypes: state.operatingrule.evaluateTypes,
}), model.actions)(EditInfo);